module.exports = __webpack_public_path__ + "static/img/bg-es.ab70de83.png";